export function MessageSvg({ size = 20, color = "#2E3C47" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4994 0C11.3278 0 11.9994 0.671573 11.9994 1.5V4.7531H8.78748C7.2078 4.7531 5.92722 6.27977 5.92722 8.16302L5.92723 10.729H3.46627C3.17061 10.729 2.89012 10.8598 2.70011 11.0864L0.883077 13.2526C0.583055 13.6102 0 13.3981 0 12.9312V1.5C0 0.671573 0.671572 0 1.5 0H10.4994Z"
        fill={color}
      />
      <path
        d="M7.00103 7.96714C7.00103 6.85999 7.90036 5.95939 9.00739 5.95797L22.0067 5.94128C23.1087 5.93986 24.0001 6.83025 24.0001 7.93235L24.0001 23.4656C24.0001 23.9265 23.4295 24.1445 23.1249 23.8L20.5941 20.9374C20.2165 20.5103 19.6736 20.2659 19.1023 20.2659L8.99192 20.2659C7.89096 20.2659 7.00109 19.3759 7.00108 18.2748L7.00103 7.96714Z"
        fill={color}
      />
    </svg>
  );
}
